export {
  config,
  css,
  getCssText,
  globalCss,
  keyframes,
  styled,
  theme,
  createTheme,
} from '@grupoboticario/flora'

export type { FloraVariants, ComponentCSSProp, CSS, Theme } from '@grupoboticario/flora'

// Transitions
export * from './transitions'
export * from './functions'
